module.exports = __webpack_public_path__ + "static/media/1.a8c4f656.jpg";